import axios from 'axios';

const uploadImage = async (_token, imageFile, folderName) => {
  if (imageFile && imageFile.name && imageFile.type) {
    const payload = new FormData();
    payload.append('attachment', imageFile);
    payload.append('file_name', imageFile.name);
    if (folderName) {
      payload.append('bucketName', folderName);
    }

    const { data } = await axios.post('/api/gcs-upload/', payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (data && data.status === 200 && data.gcsURL) {
      return data.gcsURL;
    }

    const errorMessage = data && data.message ? data.message : 'Upload gagal.';
    throw new Error(errorMessage);
  }
}

export default uploadImage;
